import React from 'react';

interface Props { size?: number }

const ClubFittingIcon: React.FC<Props> = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd" clipRule="evenodd"
      d="M12 16.6176C12 16.8279 12.1636 17 12.3636 17C12.5636 17 12.7273 16.8279 12.7273 16.6176V12.0294C12.7273 11.8191 12.5636 11.6471 12.3636 11.6471C12.1636 11.6471 12 11.8191 12 12.0294V16.6176ZM8.36364 12.0294C8.36364 11.8191 8.2 11.6471 8 11.6471C7.8 11.6471 7.63636 11.8191 7.63636 12.0294V16.6176C7.63636 16.8279 7.8 17 8 17C8.2 17 8.36364 16.8279 8.36364 16.6176V12.0294Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd" clipRule="evenodd"
      d="M12.7273 10.8824V11.6471H7.63636V10.8824H12.7273ZM6.90909 10.5V12.0294C6.90909 12.2397 7.07273 12.4118 7.27273 12.4118H13.0909C13.2909 12.4118 13.4545 12.2397 13.4545 12.0294V10.5C13.4545 10.2897 13.2909 10.1176 13.0909 10.1176H7.27273C7.07273 10.1176 6.90909 10.2897 6.90909 10.5Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd" clipRule="evenodd"
      d="M9.09091 7.05882C9.09091 6.84853 8.92727 6.67647 8.72727 6.67647C8.52727 6.67647 8.36364 6.84853 8.36364 7.05882V10.1176C8.36364 10.3279 8.52727 10.5 8.72727 10.5C8.92727 10.5 9.09091 10.3279 9.09091 10.1176V7.05882Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd" clipRule="evenodd"
      d="M6.90909 6.29412H8.36364V6.73L6.84727 6.97662C6.76909 6.99 6.72727 6.95176 6.72727 6.86765V6.48529C6.72727 6.38015 6.80909 6.29412 6.90909 6.29412ZM6 6.86765C6 7.42015 6.44 7.81588 6.95818 7.73176L8.78182 7.43735C8.96 7.40868 9.09091 7.24809 9.09091 7.05882V6.29412C9.09091 5.87162 8.76545 5.52941 8.36364 5.52941H6.90909C6.40727 5.52941 6 5.95765 6 6.48529V6.86765ZM10.3636 5.52941C10.3636 5.31912 10.2 5.14706 10 5.14706C9.8 5.14706 9.63636 5.31912 9.63636 5.52941V10.1176C9.63636 10.3279 9.8 10.5 10 10.5C10.2 10.5 10.3636 10.3279 10.3636 10.1176V5.52941Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd" clipRule="evenodd"
      d="M11.8182 4H10.3636C9.96182 4 9.63636 4.34029 9.63636 4.76662V5.33824C9.63636 5.73779 9.92909 6.09721 10.3036 6.15838L11.7691 6.39544C12.2873 6.47956 12.7273 6.08191 12.7273 5.53132V4.95588C12.7273 4.42824 12.32 4 11.8182 4ZM12 5.52941C12 5.61162 11.9564 5.64985 11.88 5.63647L10.4145 5.39941C10.3945 5.39559 10.3636 5.35735 10.3636 5.33632V4.76471H11.8182C11.9182 4.76471 12 4.84882 12 4.95397V5.52941ZM11.6364 8.20588C11.6364 7.99559 11.4727 7.82353 11.2727 7.82353C11.0727 7.82353 10.9091 7.99559 10.9091 8.20588V10.1176C10.9091 10.3279 11.0727 10.5 11.2727 10.5C11.4727 10.5 11.6364 10.3279 11.6364 10.1176V8.20588Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd" clipRule="evenodd"
      d="M13.2727 7.05882H11.6382C11.2364 7.05882 10.9109 7.40103 10.9109 7.82353V8.20588C10.9109 8.60544 11.2036 8.96294 11.5782 9.02412L13.2236 9.28985C13.6418 9.35676 14.0018 9.03368 14.0018 8.58824V7.82353C14.0018 7.40103 13.6764 7.05882 13.2745 7.05882H13.2727ZM11.6873 8.26897C11.6673 8.26515 11.6364 8.22882 11.6364 8.20779V7.82544H13.2727V8.53279L11.6873 8.27088V8.26897Z"
      fill="currentColor"
    />
  </svg>
);

export default ClubFittingIcon;
